import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
export const getPersona = () => localStorage.getItem("cs-persona") || "harry";
export const setPersonaHeader = (p) => { localStorage.setItem("cs-persona", p); api.defaults.headers.common["X-Persona"] = p; };
setPersonaHeader(getPersona());
const blocked = (msg) => toast.error(msg, { id: "access-blocked", description: "See Access Audit for the full log." });
api.interceptors.response.use((r) => r, (e) => { if (e.response?.status === 403) blocked(e.response.data?.detail); return Promise.reject(e); });
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return Array.isArray(d) ? d.map((x) => `${(x.loc || []).slice(-1)[0] || "value"}: ${x.msg}`).join("; ") : typeof d === "string" ? d : d ? JSON.stringify(d) : null;
};
export const safe = (fn) => async (...args) => {
  try { return await fn(...args); }
  catch (e) { if (e.response?.status !== 403) toast.error(errMsg(e) || e.message || "Action failed"); }
};
window.addEventListener("unhandledrejection", (e) => { if (e.reason?.response?.status === 403) e.preventDefault(); });
export const exportGuard = (persona, perm, path) => (e) => {
  if (!persona?.permissions.includes(perm)) { e.preventDefault(); api.get(path).catch(() => {}); }
};
export const withPersona = (url) => `${url}${url.includes("?") ? "&" : "?"}persona=${getPersona()}`;

export async function streamSSE(path, body, onEvent) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Persona": getPersona() },
    body: JSON.stringify(body || {}),
  });
  if (res.status === 403) { const d = await res.json(); blocked(d.detail); throw new Error(d.detail); }
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.detail || `Request failed (${res.status})`); }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i).split("\n").find((l) => l.startsWith("data: "));
      buf = buf.slice(i + 2);
      if (line) {
        try { onEvent(JSON.parse(line.slice(6))); } catch (e) { /* partial */ }
      }
    }
  }
}

export const fmtUSD = (v, compact) => {
  if (v == null) return "—";
  if (!compact) return `$${Math.round(v).toLocaleString("en-US")}`;
  const a = Math.abs(v);
  if (a >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `$${(v / 1e3).toFixed(1)}K`;
  return `$${v.toFixed(0)}`;
};

export const fmtVal = (v, format, compact) => {
  if (v == null) return "—";
  if (format === "usd") return fmtUSD(v, compact);
  if (format === "pct") return `${(v * 100).toFixed(2)}%`;
  if (format === "x") return `${v.toFixed(2)}x`;
  if (format === "num") return Number(v).toLocaleString("en-US");
  return String(v);
};

export const fmtTime = (iso) =>
  new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });

const DOC_LABEL = { rentroll: "Rent Roll", appraisal: "Appraisal", financials: "Financials", termsheet: "Term Sheet" };
export const docLabel = (id) => (id?.startsWith("doc-up-") ? "Upload" : DOC_LABEL[id?.split("-").pop()] || id);

export async function runExtract(taskId) {
  const r = await api.post(`/tasks/${taskId}/extract`);
  if (r.status !== 202) return r.data;
  for (let i = 0; i < 300; i++) {
    await new Promise((res) => setTimeout(res, 4000));
    const { data } = await api.get(`/tasks/${taskId}/extract-status`);
    if (data.status === "done") return data;
    if (data.status === "error") throw Object.assign(new Error(data.error), { response: { status: 502, data: { detail: data.error } } });
  }
  throw Object.assign(new Error("Extraction is still running"), { response: { status: 504, data: { detail: "Extraction is still running - refresh in a few minutes" } } });
}
